// src/constants/const.ts

// 🔹 Full list of Indian States & UTs
export const INDIAN_STATES = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  // Union Territories
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry",
];

// 🔹 Experience Options (1 Yr to 20+ Yrs)
export const EXPERIENCE_OPTIONS = [
  "0-1 Years",
  "1 Year",
  "2 Years",
  "3 Years",
  "4 Years",
  "5 Years",
  "6 Years",
  "7 Years",
  "8 Years",
  "9 Years",
  "10 Years",
  "11 Years",
  "12 Years",
  "13 Years",
  "14 Years",
  "15 Years",
  "16 Years",
  "17 Years",
  "18 Years",
  "19 Years",
  "20+ Years",
];

export interface CountryData {
  code: string;
  flag: string;
}

export const COUNTRIES: Record<string, CountryData> = {
  Afghanistan: { code: "+93", flag: "https://flagcdn.com/w20/af.png" },
  Albania: { code: "+355", flag: "https://flagcdn.com/w20/al.png" },
  Algeria: { code: "+213", flag: "https://flagcdn.com/w20/dz.png" },
  Andorra: { code: "+376", flag: "https://flagcdn.com/w20/ad.png" },
  Angola: { code: "+244", flag: "https://flagcdn.com/w20/ao.png" },
  AntiguaAndBarbuda: { code: "+1-268", flag: "https://flagcdn.com/w20/ag.png" },
  Argentina: { code: "+54", flag: "https://flagcdn.com/w20/ar.png" },
  Armenia: { code: "+374", flag: "https://flagcdn.com/w20/am.png" },
  Australia: { code: "+61", flag: "https://flagcdn.com/w20/au.png" },
  Austria: { code: "+43", flag: "https://flagcdn.com/w20/at.png" },
  Azerbaijan: { code: "+994", flag: "https://flagcdn.com/w20/az.png" },
  Bahamas: { code: "+1-242", flag: "https://flagcdn.com/w20/bs.png" },
  Bahrain: { code: "+973", flag: "https://flagcdn.com/w20/bh.png" },
  Bangladesh: { code: "+880", flag: "https://flagcdn.com/w20/bd.png" },
  Barbados: { code: "+1-246", flag: "https://flagcdn.com/w20/bb.png" },
  Belarus: { code: "+375", flag: "https://flagcdn.com/w20/by.png" },
  Belgium: { code: "+32", flag: "https://flagcdn.com/w20/be.png" },
  Belize: { code: "+501", flag: "https://flagcdn.com/w20/bz.png" },
  Benin: { code: "+229", flag: "https://flagcdn.com/w20/bj.png" },
  Bhutan: { code: "+975", flag: "https://flagcdn.com/w20/bt.png" },
  Bolivia: { code: "+591", flag: "https://flagcdn.com/w20/bo.png" },
  BosniaAndHerzegovina: { code: "+387", flag: "https://flagcdn.com/w20/ba.png" },
  Botswana: { code: "+267", flag: "https://flagcdn.com/w20/bw.png" },
  Brazil: { code: "+55", flag: "https://flagcdn.com/w20/br.png" },
  Brunei: { code: "+673", flag: "https://flagcdn.com/w20/bn.png" },
  Bulgaria: { code: "+359", flag: "https://flagcdn.com/w20/bg.png" },
  BurkinaFaso: { code: "+226", flag: "https://flagcdn.com/w20/bf.png" },
  Burundi: { code: "+257", flag: "https://flagcdn.com/w20/bi.png" },
  Cambodia: { code: "+855", flag: "https://flagcdn.com/w20/kh.png" },
  Cameroon: { code: "+237", flag: "https://flagcdn.com/w20/cm.png" },
  Canada: { code: "+1", flag: "https://flagcdn.com/w20/ca.png" },
  CapeVerde: { code: "+238", flag: "https://flagcdn.com/w20/cv.png" },
  CentralAfricanRepublic: { code: "+236", flag: "https://flagcdn.com/w20/cf.png" },
  Chad: { code: "+235", flag: "https://flagcdn.com/w20/td.png" },
  Chile: { code: "+56", flag: "https://flagcdn.com/w20/cl.png" },
  China: { code: "+86", flag: "https://flagcdn.com/w20/cn.png" },
  Colombia: { code: "+57", flag: "https://flagcdn.com/w20/co.png" },
  Comoros: { code: "+269", flag: "https://flagcdn.com/w20/km.png" },
  Congo: { code: "+242", flag: "https://flagcdn.com/w20/cg.png" },
  DR_Congo: { code: "+243", flag: "https://flagcdn.com/w20/cd.png" },
  CostaRica: { code: "+506", flag: "https://flagcdn.com/w20/cr.png" },
  Croatia: { code: "+385", flag: "https://flagcdn.com/w20/hr.png" },
  Cuba: { code: "+53", flag: "https://flagcdn.com/w20/cu.png" },
  Cyprus: { code: "+357", flag: "https://flagcdn.com/w20/cy.png" },
  CzechRepublic: { code: "+420", flag: "https://flagcdn.com/w20/cz.png" },
  Denmark: { code: "+45", flag: "https://flagcdn.com/w20/dk.png" },
  Djibouti: { code: "+253", flag: "https://flagcdn.com/w20/dj.png" },
  Dominica: { code: "+1-767", flag: "https://flagcdn.com/w20/dm.png" },
  DominicanRepublic: { code: "+1-809", flag: "https://flagcdn.com/w20/do.png" },
  Ecuador: { code: "+593", flag: "https://flagcdn.com/w20/ec.png" },
  Egypt: { code: "+20", flag: "https://flagcdn.com/w20/eg.png" },
  ElSalvador: { code: "+503", flag: "https://flagcdn.com/w20/sv.png" },
  EquatorialGuinea: { code: "+240", flag: "https://flagcdn.com/w20/gq.png" },
  Eritrea: { code: "+291", flag: "https://flagcdn.com/w20/er.png" },
  Estonia: { code: "+372", flag: "https://flagcdn.com/w20/ee.png" },
  Eswatini: { code: "+268", flag: "https://flagcdn.com/w20/sz.png" },
  Ethiopia: { code: "+251", flag: "https://flagcdn.com/w20/et.png" },
  Fiji: { code: "+679", flag: "https://flagcdn.com/w20/fj.png" },
  Finland: { code: "+358", flag: "https://flagcdn.com/w20/fi.png" },
  France: { code: "+33", flag: "https://flagcdn.com/w20/fr.png" },
  Gabon: { code: "+241", flag: "https://flagcdn.com/w20/ga.png" },
  Gambia: { code: "+220", flag: "https://flagcdn.com/w20/gm.png" },
  Georgia: { code: "+995", flag: "https://flagcdn.com/w20/ge.png" },
  Germany: { code: "+49", flag: "https://flagcdn.com/w20/de.png" },
  Ghana: { code: "+233", flag: "https://flagcdn.com/w20/gh.png" },
  Greece: { code: "+30", flag: "https://flagcdn.com/w20/gr.png" },
  Grenada: { code: "+1-473", flag: "https://flagcdn.com/w20/gd.png" },
  Guatemala: { code: "+502", flag: "https://flagcdn.com/w20/gt.png" },
  Guinea: { code: "+224", flag: "https://flagcdn.com/w20/gn.png" },
  GuineaBissau: { code: "+245", flag: "https://flagcdn.com/w20/gw.png" },
  Guyana: { code: "+592", flag: "https://flagcdn.com/w20/gy.png" },
  Haiti: { code: "+509", flag: "https://flagcdn.com/w20/ht.png" },
  Honduras: { code: "+504", flag: "https://flagcdn.com/w20/hn.png" },
  HongKong: { code: "+852", flag: "https://flagcdn.com/w20/hk.png" },
  Hungary: { code: "+36", flag: "https://flagcdn.com/w20/hu.png" },
  Iceland: { code: "+354", flag: "https://flagcdn.com/w20/is.png" },
  India: { code: "+91", flag: "https://flagcdn.com/w20/in.png" },
  Indonesia: { code: "+62", flag: "https://flagcdn.com/w20/id.png" },
  Iran: { code: "+98", flag: "https://flagcdn.com/w20/ir.png" },
  Iraq: { code: "+964", flag: "https://flagcdn.com/w20/iq.png" },
  Ireland: { code: "+353", flag: "https://flagcdn.com/w20/ie.png" },
  Israel: { code: "+972", flag: "https://flagcdn.com/w20/il.png" },
  Italy: { code: "+39", flag: "https://flagcdn.com/w20/it.png" },
  Jamaica: { code: "+1-876", flag: "https://flagcdn.com/w20/jm.png" },
  Japan: { code: "+81", flag: "https://flagcdn.com/w20/jp.png" },
  Jordan: { code: "+962", flag: "https://flagcdn.com/w20/jo.png" },
  Kazakhstan: { code: "+7", flag: "https://flagcdn.com/w20/kz.png" },
  Kenya: { code: "+254", flag: "https://flagcdn.com/w20/ke.png" },
  Kiribati: { code: "+686", flag: "https://flagcdn.com/w20/ki.png" },
  NorthKorea: { code: "+850", flag: "https://flagcdn.com/w20/kp.png" },
  SouthKorea: { code: "+82", flag: "https://flagcdn.com/w20/kr.png" },
  Kuwait: { code: "+965", flag: "https://flagcdn.com/w20/kw.png" },
  Kyrgyzstan: { code: "+996", flag: "https://flagcdn.com/w20/kg.png" },
  Laos: { code: "+856", flag: "https://flagcdn.com/w20/la.png" },
  Latvia: { code: "+371", flag: "https://flagcdn.com/w20/lv.png" },
  Lebanon: { code: "+961", flag: "https://flagcdn.com/w20/lb.png" },
  Lesotho: { code: "+266", flag: "https://flagcdn.com/w20/ls.png" },
  Liberia: { code: "+231", flag: "https://flagcdn.com/w20/lr.png" },
  Libya: { code: "+218", flag: "https://flagcdn.com/w20/ly.png" },
  Liechtenstein: { code: "+423", flag: "https://flagcdn.com/w20/li.png" },
  Lithuania: { code: "+370", flag: "https://flagcdn.com/w20/lt.png" },
  Luxembourg: { code: "+352", flag: "https://flagcdn.com/w20/lu.png" },
  Madagascar: { code: "+261", flag: "https://flagcdn.com/w20/mg.png" },
  Malawi: { code: "+265", flag: "https://flagcdn.com/w20/mw.png" },
  Malaysia: { code: "+60", flag: "https://flagcdn.com/w20/my.png" },
  Maldives: { code: "+960", flag: "https://flagcdn.com/w20/mv.png" },
  Mali: { code: "+223", flag: "https://flagcdn.com/w20/ml.png" },
  Malta: { code: "+356", flag: "https://flagcdn.com/w20/mt.png" },
  MarshallIslands: { code: "+692", flag: "https://flagcdn.com/w20/mh.png" },
  Mauritania: { code: "+222", flag: "https://flagcdn.com/w20/mr.png" },
  Mauritius: { code: "+230", flag: "https://flagcdn.com/w20/mu.png" },
  Mexico: { code: "+52", flag: "https://flagcdn.com/w20/mx.png" },
  Micronesia: { code: "+691", flag: "https://flagcdn.com/w20/fm.png" },
  Moldova: { code: "+373", flag: "https://flagcdn.com/w20/md.png" },
  Monaco: { code: "+377", flag: "https://flagcdn.com/w20/mc.png" },
  Mongolia: { code: "+976", flag: "https://flagcdn.com/w20/mn.png" },
  Montenegro: { code: "+382", flag: "https://flagcdn.com/w20/me.png" },
  Morocco: { code: "+212", flag: "https://flagcdn.com/w20/ma.png" },
  Mozambique: { code: "+258", flag: "https://flagcdn.com/w20/mz.png" },
  Myanmar: { code: "+95", flag: "https://flagcdn.com/w20/mm.png" },
  Namibia: { code: "+264", flag: "https://flagcdn.com/w20/na.png" },
  Nauru: { code: "+674", flag: "https://flagcdn.com/w20/nr.png" },
  Nepal: { code: "+977", flag: "https://flagcdn.com/w20/np.png" },
  Netherlands: { code: "+31", flag: "https://flagcdn.com/w20/nl.png" },
  NewZealand: { code: "+64", flag: "https://flagcdn.com/w20/nz.png" },
  Nicaragua: { code: "+505", flag: "https://flagcdn.com/w20/ni.png" },
  Niger: { code: "+227", flag: "https://flagcdn.com/w20/ne.png" },
  Nigeria: { code: "+234", flag: "https://flagcdn.com/w20/ng.png" },
  NorthMacedonia: { code: "+389", flag: "https://flagcdn.com/w20/mk.png" },
  Norway: { code: "+47", flag: "https://flagcdn.com/w20/no.png" },
  Oman: { code: "+968", flag: "https://flagcdn.com/w20/om.png" },
  Pakistan: { code: "+92", flag: "https://flagcdn.com/w20/pk.png" },
  Palau: { code: "+680", flag: "https://flagcdn.com/w20/pw.png" },
  Palestine: { code: "+970", flag: "https://flagcdn.com/w20/ps.png" },
  Panama: { code: "+507", flag: "https://flagcdn.com/w20/pa.png" },
  PapuaNewGuinea: { code: "+675", flag: "https://flagcdn.com/w20/pg.png" },
  Paraguay: { code: "+595", flag: "https://flagcdn.com/w20/py.png" },
  Peru: { code: "+51", flag: "https://flagcdn.com/w20/pe.png" },
  Philippines: { code: "+63", flag: "https://flagcdn.com/w20/ph.png" },
  Poland: { code: "+48", flag: "https://flagcdn.com/w20/pl.png" },
  Portugal: { code: "+351", flag: "https://flagcdn.com/w20/pt.png" },
  Qatar: { code: "+974", flag: "https://flagcdn.com/w20/qa.png" },
  Romania: { code: "+40", flag: "https://flagcdn.com/w20/ro.png" },
  Russia: { code: "+7", flag: "https://flagcdn.com/w20/ru.png" },
  Rwanda: { code: "+250", flag: "https://flagcdn.com/w20/rw.png" },
  SaintKittsAndNevis: { code: "+1-869", flag: "https://flagcdn.com/w20/kn.png" },
  SaintLucia: { code: "+1-758", flag: "https://flagcdn.com/w20/lc.png" },
  SaintVincentAndTheGrenadines: { code: "+1-784", flag: "https://flagcdn.com/w20/vc.png" },
  Samoa: { code: "+685", flag: "https://flagcdn.com/w20/ws.png" },
  SanMarino: { code: "+378", flag: "https://flagcdn.com/w20/sm.png" },
  SaoTomeAndPrincipe: { code: "+239", flag: "https://flagcdn.com/w20/st.png" },
  SaudiArabia: { code: "+966", flag: "https://flagcdn.com/w20/sa.png" },
  Senegal: { code: "+221", flag: "https://flagcdn.com/w20/sn.png" },
  Serbia: { code: "+381", flag: "https://flagcdn.com/w20/rs.png" },
  Seychelles: { code: "+248", flag: "https://flagcdn.com/w20/sc.png" },
  SierraLeone: { code: "+232", flag: "https://flagcdn.com/w20/sl.png" },
  Singapore: { code: "+65", flag: "https://flagcdn.com/w20/sg.png" },
  Slovakia: { code: "+421", flag: "https://flagcdn.com/w20/sk.png" },
  Slovenia: { code: "+386", flag: "https://flagcdn.com/w20/si.png" },
  SolomonIslands: { code: "+677", flag: "https://flagcdn.com/w20/sb.png" },
  Somalia: { code: "+252", flag: "https://flagcdn.com/w20/so.png" },
  SouthAfrica: { code: "+27", flag: "https://flagcdn.com/w20/za.png" },
  SouthSudan: { code: "+211", flag: "https://flagcdn.com/w20/ss.png" },
  Spain: { code: "+34", flag: "https://flagcdn.com/w20/es.png" },
  SriLanka: { code: "+94", flag: "https://flagcdn.com/w20/lk.png" },
  Sudan: { code: "+249", flag: "https://flagcdn.com/w20/sd.png" },
  Suriname: { code: "+597", flag: "https://flagcdn.com/w20/sr.png" },
  Sweden: { code: "+46", flag: "https://flagcdn.com/w20/se.png" },
  Switzerland: { code: "+41", flag: "https://flagcdn.com/w20/ch.png" },
  Syria: { code: "+963", flag: "https://flagcdn.com/w20/sy.png" },
  Taiwan: { code: "+886", flag: "https://flagcdn.com/w20/tw.png" },
  Tajikistan: { code: "+992", flag: "https://flagcdn.com/w20/tj.png" },
  Tanzania: { code: "+255", flag: "https://flagcdn.com/w20/tz.png" },
  Thailand: { code: "+66", flag: "https://flagcdn.com/w20/th.png" },
  TimorLeste: { code: "+670", flag: "https://flagcdn.com/w20/tl.png" },
  Togo: { code: "+228", flag: "https://flagcdn.com/w20/tg.png" },
  Tonga: { code: "+676", flag: "https://flagcdn.com/w20/to.png" },
  TrinidadAndTobago: { code: "+1-868", flag: "https://flagcdn.com/w20/tt.png" },
  Tunisia: { code: "+216", flag: "https://flagcdn.com/w20/tn.png" },
  Turkey: { code: "+90", flag: "https://flagcdn.com/w20/tr.png" },
  Turkmenistan: { code: "+993", flag: "https://flagcdn.com/w20/tm.png" },
  Tuvalu: { code: "+688", flag: "https://flagcdn.com/w20/tv.png" },
  Uganda: { code: "+256", flag: "https://flagcdn.com/w20/ug.png" },
  Ukraine: { code: "+380", flag: "https://flagcdn.com/w20/ua.png" },
  UnitedArabEmirates: { code: "+971", flag: "https://flagcdn.com/w20/ae.png" },
  UnitedKingdom: { code: "+44", flag: "https://flagcdn.com/w20/gb.png" },
  UnitedStates: { code: "+1", flag: "https://flagcdn.com/w20/us.png" },
  Uruguay: { code: "+598", flag: "https://flagcdn.com/w20/uy.png" },
  Uzbekistan: { code: "+998", flag: "https://flagcdn.com/w20/uz.png" },
  Vanuatu: { code: "+678", flag: "https://flagcdn.com/w20/vu.png" },
  VaticanCity: { code: "+39", flag: "https://flagcdn.com/w20/va.png" },
  Venezuela: { code: "+58", flag: "https://flagcdn.com/w20/ve.png" },
  Vietnam: { code: "+84", flag: "https://flagcdn.com/w20/vn.png" },
  Yemen: { code: "+967", flag: "https://flagcdn.com/w20/ye.png" },
  Zambia: { code: "+260", flag: "https://flagcdn.com/w20/zm.png" },
  Zimbabwe: { code: "+263", flag: "https://flagcdn.com/w20/zw.png" },
};